interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  description: string;
}

interface FeaturesSectionProps {
  title: string;
  subtitle: string;
  items: FeatureItem[];
}

export default function FeaturesSection({ title, subtitle, items }: FeaturesSectionProps) {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            {title}
          </h2>
          <p className="text-sm text-foreground-600">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item) => (
            <div
              key={item.id}
              className="group p-6 rounded-2xl border border-background-200/70 bg-background-50 hover:bg-background-100 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>

              <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>

              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}